/**
 * Shorter way to access window.Checkout.settings. Also will be useful if we want typings for settings.
 */
export const settings = () => window.Checkout.settings;
